import { Link } from "react-router-dom";
import { useGetPageQuery, useSendFormMutation } from "../../redux/services/crmAPI";
import { useEffect, useState } from "react";
import moment from "moment/moment";
import { succsesDataDeleteAlert } from "../../alerts/alerts";
import { useSelector } from "react-redux";

const Requests = () => {
    const permissions = useSelector((state) => state.status.permissions);

    // const [selectedStore, setSelectedStore] = useState("");
    const [selectedStatus, setSelectedStatus] = useState(1);
    const [requestsList, setRequestsList] = useState([]);

    // const { data: stores } = useGetPageQuery("stores");
    const { data: satuces } = useGetPageQuery("request-statuses");
    const { data: requests, refetch: refetchRequestS } = useGetPageQuery(
        "requests?request_status_id=" + selectedStatus
    );
    const [deleterequests, { isLoading, isError }] = useSendFormMutation();

    const listCheckHandler = (e) => {
        if (e.target.checked) {
            setRequestsList([...requestsList, e.target.value]);
        } else if (!e.target.checked) {
            setRequestsList([...requestsList.filter((id) => id !== e.target.value)]);
        }
    };

    const checkAllHandler = () => {
        setRequestsList(requests.data.map((request) => request.id.toString()));
    };

    const deleteRequestsHandler = async () => {
        for (const request of requestsList) {
            await deleterequests({ body: {}, url: "requests/" + request, method: "DELETE" });
        }

        if (!isError) {
            succsesDataDeleteAlert();
        }

        await refetchRequestS();
    };

    useEffect(() => {
        const refetch = async () => {
            refetchRequestS();
        };
        refetch();
    }, []);

    return (
        <>
            {satuces && requests && (
                <div className="content">
                    <div className="col-12">
                        <div className="page-header d-flex justify-content-between align-items-center mb-3">
                            <div className="header">
                                <h1>Запити</h1>
                            </div>
                            <div className="page-header__button">
                                <div className="float-right">
                                    <Link to={"/request"} className="add btn btn-primary">
                                        Додати запит
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <a className="check_all" onClick={checkAllHandler}>
                            Виділити все
                        </a>
                        <div className="row">
                            <div className="col-12 col-sm-6 col-md-9">
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th data-field="check"></th>
                                            <th data-field="id" className="no-mobile">
                                                ID
                                            </th>
                                            <th data-field="user_name">Клієнт</th>
                                            <th data-field="user_phone" className="no-mobile">
                                                Телефон
                                            </th>
                                            <th data-field="user_product">Товар</th>
                                            <th data-field="user_status" className="no-mobile">
                                                Статус
                                            </th>
                                            <th data-field="user_date" className="no-mobile">
                                                Створено
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {requests.data.map((request) => {
                                            return (
                                                <tr>
                                                    <td className="check_area text-right">
                                                        <div className="custom-control custom-checkbox">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                checked={requestsList.includes(request.id.toString())}
                                                                value={request.id}
                                                                onChange={(e) => listCheckHandler(e)}
                                                            />
                                                            <label className="custom-control-label" for="check_u13">
                                                                &nbsp;
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td className="no-mobile">#{request.id}</td>
                                                    <td>
                                                        <Link to={"/request/" + request.id}>{request.name}</Link>
                                                        <div className="on-mobile">{request.phone}</div>
                                                    </td>
                                                    <td className="no-mobile">{request.phone}</td>
                                                    <td>{request.product}</td>
                                                    <td className="no-mobile">
                                                        {satuces[request.request_status_id - 1].title}
                                                    </td>
                                                    <td className="no-mobile">
                                                        {moment(request.updated_at).format("DD.MM.YYYY")}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                                {permissions.includes("request_edit") || permissions.includes("all") ? (
                                    <div className="d-flex mb-3">
                                        <select name="action" className="form-select" style={{ width: "auto" }}>
                                            <option value="delete">Видалити</option>{" "}
                                        </select>
                                        <button className="btn btn-info mx-3" onClick={deleteRequestsHandler}>
                                            {isLoading ? "Завантаження" : "Виконати"}
                                        </button>
                                    </div>
                                ) : null}
                            </div>
                            <div className="col-xs-12 col-sm-6 col-md-3">
                                <div className="list-group margin20">
                                    {satuces.map((status) => {
                                        return (
                                            <div
                                                className={
                                                    selectedStatus === status.id
                                                        ? "list-group-item fake-a active"
                                                        : "list-group-item fake-a"
                                                }
                                                onClick={() => setSelectedStatus(status.id)}
                                                key={status.id}
                                            >
                                                {status.title}
                                            </div>
                                        );
                                    })}
                                </div>
                                {/* <div className="list-group margin20">
                                    <div
                                        className={
                                            selectedStore === ""
                                                ? "list-group-item fake-a active"
                                                : "list-group-item fake-a"
                                        }
                                        onClick={() => setSelectedStore("")}
                                    >
                                        Всі магазини
                                    </div>
                                    {stores.data.map((store) => {
                                        return (
                                            <div
                                                className={
                                                    selectedStore === store.id
                                                        ? "list-group-item fake-a active"
                                                        : "list-group-item fake-a"
                                                }
                                                onClick={() => setSelectedStore(store.id)}
                                                key={store.id}
                                            >
                                                {store.title}
                                            </div>
                                        );
                                    })}
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Requests;
